import { SET_MENU_LIST, CLEAR_MENU_LIST } from '../mutation-types'

// 该模块的初始状态
const state = {
  list: []
}

// 相关的 mutations
const mutations = {
  [SET_MENU_LIST] (state, list) {
    state.list.push(...list)
  },
  [CLEAR_MENU_LIST] (state) {
    state.list = []
  }
}

const actions = {
  setMenuList: ({ commit }, list) => {
    commit('SET_MENU_LIST', list)
  },
  clearMenuList: ({ commit }) => {
    commit('CLEAR_MENU_LIST')
  }
}

const getters = {
  list: state => {
    return state.list
  },
  jsonData: state => {
    return state.json
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
